import {Component, OnInit} from '@angular/core';
@Component({
  selector: 'app-logisticare-uts-report',
  templateUrl: './logisticare-uts-report.component.html',
  styleUrls: ['./logisticare-uts-report.component.scss']
})
export class LogisticareUtsReportComponent implements OnInit {
  constructor( ) { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/manager-reports/logisticare-uts-report/logisticare-uts-report.component.ts